import {getCookieValue} from "./utilityFunctions";
import {ANALYTICS_COOKIES} from "./constants";

export default () => {
    'use strict';

    // Open PDF in new tab on form submit
    document.querySelectorAll('[data-form-pdf]').forEach(wrapper => {
        const url: any = wrapper.getAttribute('data-form-pdf');
        const buttonLabel = wrapper.getAttribute('data-download-label');
        const form = wrapper.querySelector('[data-freeform]');

        form?.addEventListener("freeform-ajax-success", () => {
            const pdfDownloadHTML = `
                <div class="d-flex justify-content-center mb-5">
                    <a class="base-link text-center" href="${url}" download target="_blank">
                        ${buttonLabel}
                    </a>
                <div>
            `;
            form.insertAdjacentHTML('beforeend', pdfDownloadHTML);
            setTimeout(() => {
                window.open(url, '_blank');
            }, 1000)
        });
    })

    const freeforms = document.querySelectorAll('[data-freeform]');

    freeforms.forEach(freeform => {

        // Adjust accessibility of radio or checkbox buttons
        const radioInputs = freeform.querySelectorAll('.freeform-fieldtype-radios');

        radioInputs.forEach(radioInput => {
            radioInput.setAttribute('role', 'radiogroup');
            const radioGroupLabel = radioInput.querySelector('label');

            if (radioGroupLabel) {
                let radioGroupLabelId = radioGroupLabel.getAttribute('id');
                if (!radioGroupLabelId) {
                    radioGroupLabelId = radioGroupLabel.getAttribute('for') + '-label';
                    radioGroupLabel.setAttribute('id', radioGroupLabelId);
                }
                radioInput.setAttribute('aria-labelledby', radioGroupLabelId);
                radioInput.setAttribute('id', radioGroupLabel.getAttribute('for') ?? "")

                const newGroupLabel = document.createElement('div');
                newGroupLabel.textContent = radioGroupLabel?.textContent ?? ''
                newGroupLabel.setAttribute('id', radioGroupLabelId);
                newGroupLabel.classList.add('label', 'radiogroup-label');

                if (radioGroupLabel.classList.contains('required')) {
                    newGroupLabel.classList.add('required');
                    newGroupLabel.insertAdjacentHTML('beforeend', '<span aria-hidden="true" class="required-icon">*</span>')
                }
                radioGroupLabel?.removeAttribute('for');
                radioGroupLabel.replaceWith(newGroupLabel);
            }
        })

        freeform.addEventListener('freeform-ready', function (event) {
            // @ts-ignore
            const {options} = event;
            // @ts-ignore
            const {freeform: freeformInstance} = event.target;
            options.scrollElement = document.querySelector('body');
            options.scrollToAnchor = false;

            // Fix required inputs
            const requiredFields = freeform.querySelectorAll('[data-required]');
            requiredFields.forEach(requiredField => {
                requiredField.setAttribute('aria-required', '');
            })
            const requiredLabels = freeform.querySelectorAll('label.required');
            requiredLabels.forEach(requiredLabel => {
                requiredLabel.insertAdjacentHTML('beforeend', '<span aria-hidden="true" class="required-icon">*</span>');
            })

            // Add correct error classes
            freeformInstance.setOption("errorClassList", ["list-unstyled", "errors"]);
        });
        // Show alert banner on form error
        freeform.addEventListener('freeform-ajax-error', (e: any) => {
            if (!e.errors) {
                const toast = document.querySelector('[data-form-server-error]');
                window.bootstrap.Toast.getOrCreateInstance(toast).show();
            }
        });

        // Adjust accessibility for errors
        freeform.addEventListener('freeform-render-form-errors', (event) => {
            event.preventDefault();
            // @ts-ignore
            const {form} = event;
            const errorFields = form.querySelectorAll('input.is-invalid') as HTMLElement[];
            errorFields.forEach(errorField => {
                errorField.setAttribute('aria-invalid', 'true');
                const errorMessage = errorField.nextElementSibling;
                if (errorMessage?.hasAttribute('data-field-errors')) {
                    const errorMessageId = errorField.getAttribute('id') + '-error';
                    errorMessage.setAttribute('id', errorMessageId);
                    errorField.setAttribute('aria-describedby', errorMessageId);
                }
            })
            if (errorFields.length) {
                errorFields[0].focus();
            }
        })

        freeform.addEventListener('freeform-remove-field-messages', (event) => {
            // @ts-ignore
            const {form} = event;
            // Remove aria invalid attribute and describedby for no longer visible error messages
            const errorFields = form.querySelectorAll('input.is-invalid') as HTMLElement[];
            errorFields.forEach(errorField => {
                errorField.removeAttribute('aria-invalid');
                errorField.removeAttribute('aria-describedby');
            })
        })

        freeform.addEventListener("freeform-ajax-before-submit", (event) => {
            // @ts-ignore
            const {data} = event;
            let cookieConsent = false;

            // @ts-ignore
            window.ppms?.cm.api('getComplianceSettings',
                // On fulfilled
                (consentResponse: any) => {
                    cookieConsent = !!consentResponse.consents?.analytics?.status ?? false;
                },
                // On rejected
                (error: string|object) => {
                    console.log('Couldn\'t fetch cookie compliance', error)
                });

            if(cookieConsent) {
                // Attach UTM params to form data if user has consented to cookies
                const analyticsCookieValue = getCookieValue(ANALYTICS_COOKIES);
                data.set("session-params", analyticsCookieValue);
            }

            // Adjust the hidden ref url value
            data.set("refurl", window.location.href);
        })

        // Set successful form filled session cookie
        freeform.addEventListener("freeform-ajax-success", () => {
            const formHandle = freeform.getAttribute('data-handle') ?? 'true';
            document.cookie = 'formFilled=' + formHandle + ';path=/; SameSite=Lax; Secure';
            const successMessage = freeform.querySelector('[data-freeform-success]') as HTMLElement;
            if (successMessage) {
                successMessage.focus({preventScroll: false});
                setTimeout(() => {
                    window.scrollBy({
                        top: successMessage.getBoundingClientRect().top - 100,
                        behavior: 'smooth'
                    })
                }, 150)

            }
        })
    })
}
